import React, { ReactElement, useEffect, useState } from 'react'
import { history, redirectTo } from 'ui/customHooks/useHistory'
import { useLocation } from 'react-router-dom'
import {
  MainMenuProps,
  MenuListItemsProps,
  MenuProps,
  SubMenuProps
} from 'typings/menu'
import { hasModulePermission } from 'helpers/user'
import { setPageKind } from 'helpers/analytics'
import { FA_TIMES } from 'const/icons'
import routePaths from 'const/routePaths'
import MenuListItem from './MenuListItem'
import {
  CloseIcon,
  MenuClose,
  MenuContainer,
  MenuContainerWrapper,
  MobileMenuContainer,
  NavigationModal
} from './subcomponents'
import { useUpdatedMenuList } from './helpers'

const Menu = ({ isMenuActive, closeMenu }: MenuProps): ReactElement => {
  const [activeMenu, setActiveMenu] = useState<string>('summary')
  const [expandedMenu, setExpandedMenu] = useState('summary')
  const location = history.location.pathname
  const MenuRef = React.useRef(null)

  const menuItems = useUpdatedMenuList()

  const changeActiveMenu = (currentMenu: string, sourcePath: string): void => {
    if (sourcePath === 'viewStatement') {
      setPageKind(routePaths.statement, 'account managment')
      redirectTo(routePaths.statement)
    } else if (
      sourcePath === 'emailStatement' &&
      currentMenu === 'accountMgmt'
    ) {
      setPageKind(routePaths.emailStatement, 'account managment')
      redirectTo(routePaths.emailStatement)
    } else if (sourcePath === 'statements') {
      setPageKind(routePaths.statement, 'billing')
      redirectTo(routePaths.statement)
    }
    if (isMenuActive) {
      closeMenu()
    }

    setActiveMenu(currentMenu)
    setExpandedMenu('')
  }

  const getActiveMenu = (): void => {
    let activeMenuLink = ''
    menuItems.forEach((menu: MainMenuProps) => {
      if (menu && menu.isSubMenu) {
        menu.subMenuItems.forEach((submenu: SubMenuProps) => {
          activeMenuLink =
            submenu.path === location ? menu.menuId : activeMenuLink
        })
      } else {
        activeMenuLink = menu.path === location ? menu.menuId : activeMenuLink
      }
    })
    setActiveMenu(activeMenuLink)
  }

  const locationName = useLocation().pathname

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(getActiveMenu, [locationName])

  let isActive = false

  let menuData: Partial<MenuListItemsProps> = {
    isMenuActive,
    changeActiveMenu
  }

  const renderMenuItems = () =>
    menuItems.map((item: MainMenuProps) => {
      const { menuId } = item
      isActive = menuId === activeMenu
      menuData = { ...menuData, item, isActive }
      return (
        hasModulePermission(menuId) && (
          <MenuListItem
            key={menuId}
            data-test="menu-list-item"
            expandedMenu={expandedMenu}
            setExpandedMenu={setExpandedMenu}
            {...menuData}
          />
        )
      )
    })

  return (
    <>
      <NavigationModal
        id="NavigationModal"
        aria-modal
        aria-label="Navigation"
        aria-hidden={!isMenuActive}
        aria-describedby="NavigationModalDescription"
        headerRef={MenuRef}
        isOpen={isMenuActive}
      >
        {isMenuActive && (
          <MobileMenuContainer id="NavigationModalDescription">
            {renderMenuItems()}
            <li>
              <MenuClose
                data-test="closeMenu"
                aria-label="Close Menu"
                onClick={closeMenu}
              >
                <CloseIcon name={FA_TIMES} />
              </MenuClose>
            </li>
          </MobileMenuContainer>
        )}
      </NavigationModal>
      <MenuContainerWrapper>
        <MenuContainer>{renderMenuItems()}</MenuContainer>
      </MenuContainerWrapper>
    </>
  )
}

export default Menu
